import React, { useState, useEffect } from "react";
import { toast } from "../../component/component";
import config from "../../component/config";
import moment from "moment";
import Loader from "../component/loader";
import crypto from "crypto-js";
import {
  DropdownList,
  Input,
  Select,
  TextBox,
} from "../../component/form-control";
import { pgw } from "../../component/api";
import { useNavigate } from "react-router-dom";

const OnlinePayment = (props) => {
  const [payment_type, setPayment_type] = useState();
  const [payment_bill_no, setPayment_bill_no] = useState();
  const [loading, setLoading] = useState(false);
  const [transactionType, setTransactionType] = useState([]);

  const navigate = useNavigate();

  const isEnabled = (opt) => {
    if (props.options) {
      const option = props.options.find((_) => _.type === opt);
      return option ? option.enabled : false;
    } else return false;
  };

  const urlKeri = props.options
    ? props.options.find((_) => _.type === "keri").url
    : "";

  const getTransactionType = async () => {
    setLoading(true);
    await pgw
      .get(`/online/settings/Online Transaction`)
      .then((res) => {
        const { data, success } = res.data;
        if (success) {
          setPayment_type(data[0].type);
          setTransactionType(
            data.map((i) => {
              return { text: i.name, value: i.type };
            })
          );
        }
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast("Error encountered", "", "error");
      });
  };

  const isValid = (date) => {
    if (new Date(moment(new Date()).format("YYYY-MM-DD")) > new Date(date)) {
      toast("Billing is already expired!", "", "warning");
      return false;
    }
    return true;
  };

  const isPaid = async (billNo, Type, transType) => {
    let temp = false;
    await pgw.get(`/online/misc/validate/${billNo}/${Type}`).then((r) => {
      if (r.data.data === "Paid") {
        toast("Billing is already paid!", "", "info");
        temp = true;
      }
    });

    if (transType === "delivery" && temp) {
      window.location = process.env.REACT_APP_KERI;
    } else return temp;
  };

  const proceedToPayment = (data, billNo, Type) => {
    const enc = crypto.AES.encrypt(JSON.stringify(data), config.secretKey);

    const encBillNo = crypto.AES.encrypt(billNo, config.secretKey).toString();

    sessionStorage.setItem("data", enc);
    navigate(`/payment/${Type}/${encBillNo.split("/")[0]}}`);
  };

  const searchMiscellaneous = async (billNo, transType) => {
    setLoading(true);
    await pgw
      .get(`/online/misc/${billNo}`)
      .then(async (res) => {
        const { data } = res.data;
        if (!data) {
          toast("Record not found!", "", "info");
          return;
        }

        /* Validate validity */
        if (!isValid(data.validity)) return;

        /* Validate Payment */
        if (await isPaid(billNo, "misc", transType)) return;

        proceedToPayment(data, billNo, "misc");
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false);
        toast("Error encountered", "", "error");
      });
  };

  const searchRealProperty = async (billNo, transType) => {
    setLoading(true);
    await pgw
      .get(`/online/rpt-billing/${billNo}`)
      .then(async (res) => {
        const { data } = res.data;
        let total_amount = 0;

        if (data.length === 0) {
          toast("Record not found!", "", "info");
          return;
        }

        //data.map((item) => (total_amount += item.total));
        const { bill_no, name, date, remarks, validity } = data[0];

        /* Validate validity */
        if (!isValid(validity)) return;

        /* Validate Payment */
        if (await isPaid(billNo, "rpt", transType)) return;

        let temp = {
          bill_no,
          name,
          date,
          remarks,
          validity: moment(new Date(validity)).format("MMM-DD-YYYY"),
          total_amount,
        };

        await pgw
          .get(`/online/rpt-billing/details/${billNo}`)
          .then((details) => {
            const d2 = details.data.data;
            temp.billingDetails = d2.slice(parseInt(`-${d2.length - 1}`));
            temp.billingDetails.map(
              (item) => (temp.total_amount += item.total)
            );
          })
          .catch((e) => {
            return;
          });

        proceedToPayment(temp, billNo, "rpt");
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false);
        toast("Error fetching data.", "", "error");
      });
  };

  const searchRecord = (billNo, Type, transType) => {
    setLoading(true);
    switch (Type.toLowerCase()) {
      case "misc":
        searchMiscellaneous(billNo, transType);
        break;

      case "rpt":
        searchRealProperty(billNo, transType);
        break;

      default:
        this.setState({ loading: false });
        break;
    }
  };

  useEffect(() => {
    sessionStorage.clear();
    getTransactionType();
    return () => console.log("Clean up");
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="max-w-md mx-auto border-2 border-green-900 rounded p-5 mb-10">
        <div className="mb-5 border-b pb-2">
          <div className="text-xl font-bold">Online Payment</div>
          <em className="text-sm text-gray-400">
            You may now pay using the Billing Number here
          </em>
        </div>
        <form
          method="post"
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            searchRecord(payment_bill_no, payment_type, "payment");
          }}
        >
          <Select
            _class="mb-5"
            label="Transaction Type"
            value={payment_type}
            onChange={setPayment_type}
            items={transactionType}
          />

          <Input
            _class="mb-5"
            label="Billing Number"
            value={payment_bill_no}
            onChange={setPayment_bill_no}
          />
          <button
            className="text-sm ms-auto text-center flex bg-sky-600 rounded text-white hover:bg-sky-900 hover:border-white"
            disabled={loading}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
              />
            </svg>{" "}
            Submit
          </button>
        </form>
        <div className="mt-5 border-t pt-2 text-sm">
          You may opt to request for the delivery of your Official Receipt{" "}
          <a
            href={urlKeri}
            className="font-bold text-orange-500 hover:text-orange-700"
          >
            here
          </a>
        </div>
      </div>
    </>
  );
};

export default OnlinePayment;
